import { render, staticRenderFns } from "./PickupTimerItem.vue?vue&type=template&id=70a8f444&scoped=true"
import script from "./PickupTimerItem.vue?vue&type=script&lang=js"
export * from "./PickupTimerItem.vue?vue&type=script&lang=js"
import style0 from "./PickupTimerItem.vue?vue&type=style&index=0&id=70a8f444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a8f444",
  null
  
)

export default component.exports